export default "__VITE_ASSET__5X7aKq37__";